module.exports = __webpack_public_path__ + "static/media/mama-burger-combo-en.b3bb49b2.jpg";